import {
  Box,
  Button,
  Container,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import PlayButton from "../../../components/button/PlayButton";
import Loader from "../../../components/loader/Loader";
import setKey from "../../../hooks/setKey";
import useIndex from "../../../hooks/useIndex";
import BackGroundImg from "../../../assets/img/imagen-sol.svg";
import { Notify, Report } from "notiflix";
import AddMoneyCard from "../account/AddMoneyCard";
import Resultado from "./Resultado";
import InputGame from "./InputGame";
import {
  makeFullGame,
  makePublicGame,
} from "../../../data/api/game/GameRoutes";
import AwardsTable from "./AwardsTable";
import validErrors from "../../../hooks/validErrors";
import Logo from "../../../assets/img/logo.png";
import GanacolCard from "./GanacolCard";
import GanacolBottomMenu from "./GanacolBottomMenu";
import AwardsModal from "./Modal/Awards/AwardsModal";
import PlaysStatsModal from "./Modal/PlayStats/PlaysStatsModal";
import RechargeCodeModal from "./Modal/Recharge/RechargeCodeModal";
import AuthModal from "../../auth/AuthModal";
import { checkCode, validCode } from "../../../data/api/incomes/IncomeRoutes";
import { useLocation, useNavigate } from 'react-router-dom';
import CombosModal from "./Modal/Combos/CombosModal";
import BingoBackground from "./BingoBackground";

const Game = ({ handleOpen, setCodeWin, setWinData }) => {
  const { auth, token, validateUser } = useIndex();
  const location = useLocation();
  const navigate = useNavigate();
  const isGameRoute = location.pathname === "/ganacol/dashboard/game";

  const [openPay, setOpenPay] = useState(false);

  const [result, setResult] = useState({});
  const [game, setGame] = useState({});
  const [confirmHit, setConfirmHit] = useState({});

  const [load, setLoad] = useState(false);
  const [gameCode, setGameCode] = useState("");
  const [disBut, setDisBut] = useState(0);

  const [openAwards, setOpenAwards] = useState(false);
  const [openPlays, setOpenPlays] = useState(false);
  const [openRecharge, setOpenRecharge] = useState(false);
  const [openCombos, setOpenCombos] = useState(false);
  const [successTick, setSuccessTick] = useState(0);

  const [ballot, setBallot] = useState([
    { id: setKey(), value: "", maxLength: "1" },
    { id: setKey(), value: "", maxLength: "1" },
    { id: setKey(), value: "", maxLength: "1" },
    { id: setKey(), value: "", maxLength: "1" },
    { id: setKey(), value: "", maxLength: "1" },
    { id: setKey(), value: "", maxLength: "1" },
  ]);

  const ValidBall = (arr) => {
    let res = true;
    arr.map((item) => {
      const validLeng = arr.filter((item2) => item2 === item);
      if (validLeng.length > 1) {
        res = false;
      }
      return null;
    });
    return res;
  };

  const disabledButtonInGame = async () => {
    setDisBut(1);
    setTimeout(function () {
      setDisBut(0);
    }, 6000);
  };

  const PlayGame = async () => {
    const balls = ballot.map((item) => item.value);
    if (balls.includes("")) {
      Notify.failure("Debe completar todas las casillas");
      return;
    }
    if (!ValidBall(balls)) {
      Notify.failure("Se encontraron valores repetidos");
      return;
    }

    setLoad(true);
    try {
      const data = {
        move1: balls[0],
        move2: balls[1],
        move3: balls[2],
        move4: balls[3],
        move5: balls[4],
        move6: balls[5],
        game_type_id: 1,
        code: gameCode,
      };
      const game =
        auth && token
          ? await makeFullGame(token, data)
          : await makePublicGame(data);

      if (game?.data.success) {
        Notify.success(game?.data.message);
        disabledButtonInGame();
        setResult(game?.data.data.result);
        setGame(game?.data.data.game);
        setConfirmHit(game?.data.data.confirm_hit);
        if (!(auth && token)) {
          setWinData(game?.data.data);
        }
        // Nota: NO disparamos notifyUserWin aquí. El correo de ganador
        // ya lo manda el backend automáticamente desde
        // GameGanacolController::makeFullGame → WinnerController::store
        // (para auth) o desde AuthController::processWinnerForCodeWin
        // (para usuarios que se registran/logean tras ganar anónimo).
        // Tener el frontend llamando además a /api/winner-mail
        // resultaba en correos duplicados.
      }
    } catch (error) {
      // Caso especial: usuario sin permiso para jugar. El backend lo
      // marca con code='GAME_DISABLED'. Mostramos un Report con info de
      // contacto en vez del Notify genérico.
      if (error?.response?.data?.code === 'GAME_DISABLED') {
        Report.warning(
          'No puedes jugar',
          'Tu usuario no está habilitado para jugar. Si deseas hacerlo, por favor contáctate con el administrador del sistema.',
          'Contactar',
          () => navigate('/contact'),
          { backOverlayColor: 'rgba(0,0,0,0.5)' }
        );
      } else {
        validErrors(error);
      }
    } finally {
      setLoad(false);
      if (auth && token) {
        validateUser();
      }
    }
  };

  const assignCode = async (dataForm) => {
    if (auth && token) {
      setLoad(true);

      try {
        const { data } = await validCode(token, { 'code': dataForm });
        if (data?.success) {
          validateUser();
          Notify.success(data?.message);
          setSuccessTick((x) => x + 1);
        }
      } catch (error) {
        validErrors(error);
      } finally {
        setLoad(false);
      }
    } else {
      // UNAUTH: antes mostrábamos un éxito optimista sin pegarle al
      // backend, así que un código inválido (p. ej. privado) recién
      // fallaba al jugar. Ahora consultamos checkCode para validar
      // contra las mismas reglas (existe / no expirado / no usado /
      // privado-requiere-sesión) sin consumir el código. El consumo
      // real ocurre en makePublicGame cuando el usuario juega.
      //
      // No usamos setSuccessTick (que limpiaría el input del modal),
      // solo cerramos el modal — el código validado debe permanecer
      // en gameCode para que handleSendGame lo envíe al jugar.
      setLoad(true);
      try {
        const { data } = await checkCode({ code: dataForm });
        if (data?.success) {
          Notify.success(data?.message ?? 'Código válido.');
          setOpenRecharge(false);
        }
      } catch (error) {
        validErrors(error);
      } finally {
        setLoad(false);
      }
    }
  }

  return (
    <>
      {load && <Loader />}

      <Page>
        <BingoBackground coinCount={10} ballCount={8} />

        <Content>
          <Header>
            <img src={Logo} alt="logo" />
            <Typography className="title">Bingo Social</Typography>
            <Typography className="title">Fenabocol</Typography>
          </Header>

          {!isGameRoute && (
            <ContentLogin>
              <Button
                variant="contained"
                color="error"
                size="large"
                onClick={handleOpen}
                sx={{ borderRadius: "12px", fontWeight: 900 }}
              >
                Ingresar
              </Button>
            </ContentLogin>
          )}

          <GanacolCard
            result={result}
            game={game}
            confirmHit={confirmHit}
            handleOpen={handleOpen}
            setCodeWin={setCodeWin}
            ballot={ballot}
            setBallot={setBallot}
            ValidBall={ValidBall}
            PlayGame={PlayGame}
          />

          <GanacolBottomMenu
            onAwardsClick={() => setOpenAwards(true)}
            onPlaysClick={() => setOpenPlays(true)}
            onRechargeClick={() => setOpenRecharge(true)}
            onCombosClick={() => setOpenCombos(true)}
          />

          <AwardsModal open={openAwards} onClose={() => setOpenAwards(false)} />

          <PlaysStatsModal
            open={openPlays}
            onClose={() => setOpenPlays(false)}
            handleOpen={handleOpen}
          />

          <RechargeCodeModal
            open={openRecharge}
            onClose={() => setOpenRecharge(false)}
            gameCode={gameCode}
            setGameCode={setGameCode}
            onSubmit={assignCode}
            successTick={successTick}
          />

          <CombosModal
            open={openCombos}
            onClose={() => setOpenCombos(false)}
          />
        </Content>
      </Page>
    </>
  );
};

export default Game;

const Page = styled(Box)`
  min-height: calc(100%);
  background: #132469;
  padding: 24px 16px 32px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    min-height: 100dvh;
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

const Header = styled.div`
  display: grid;
  place-items: center;
  gap: 8px;

  img {
    width: 90px;
  }

  .title {
    text-transform: uppercase;
    color: #ebc84b;
    font-weight: 900;
    letter-spacing: 0.04em;
    font-size: clamp(2.2rem, 4vw, 3.6rem);
    line-height: 1;
  }
`;

const ContentLogin = styled.div`
  width: min(900px, 100%);
  display: flex;
  justify-content: center;
`;
